<input #input hidden [id]="controlId" [value]="value" />
<div class="d-flex flex-column gap-1">
  <div
    [attr.contenteditable]="disabled ? false : 'plaintext-only'"
    #content
    role="textbox"
    aria-multiline="true"
    [attr.aria-labelledby]="labelId"
    class="textarea-input"
    (input)="handleInput($event)"
    (paste)="handlePaste($event)"
    (blur)="handleBlur()"
    [class.error]="error"
    [class.disabled]="disabled"></div>
  <div class="d-flex justify-content-between">
    <span *ngIf="hintText" class="review-input-hint">{{ hintText }}</span>
    <span class="char-count" *ngIf="maxLength">{{ input.value.length }}/{{ maxLength }}</span>
  </div>
</div>
